module.exports = __webpack_public_path__ + "static/media/Physio.aeac7126.svg";